export const actions = {
  TIPOS_SVG_LOAD_REQUESTED: 'TIPOS_SVG_LOAD_REQUESTED',
  TIPOS_SVG_LOAD_SUCCEEDED: 'TIPOS_SVG_LOAD_SUCCEEDED',
  TIPOS_SVG_LOAD_FAILED: 'TIPOS_SVG_LOAD_FAILED',

  TIPOS_SVG_INSERT_REQUESTED: 'TIPOS_SVG_INSERT_REQUESTED',
  TIPOS_SVG_INSERT_SUCCEEDED: 'TIPOS_SVG_INSERT_SUCCEEDED',
  TIPOS_SVG_INSERT_FILED: 'TIPOS_SVG_INSERT_FILED',
}

export const getTiposSvgAction = dispatch => {
  dispatch({
    type: actions.TIPOS_SVG_LOAD_REQUESTED,
  })
}

export const onSubmitInsertTipoDisenoSvgAction = (dispatch, tipoDisenoSvg) => {
  dispatch({
    type: actions.TIPOS_SVG_INSERT_REQUESTED,
    payload: tipoDisenoSvg,
  })
}
